import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { typeSupport } from "../../../Editor/utils";
import classes from "./VideoUploadPopup.module.css";
import lock from '../../../assests/lock.png'
import unlock from '../../../assests/unlock.png'

const VideoUploadPopup = ({ close, addCallback, initValues = {} }) => {
    const ASPECT_RATIO = 16 / 9;

    const { texts } = useSelector(state => state.translate);

    const [lockSizes, setLockSizes] = useState(true)
    const [values, setValues] = useState({
        top: '10px',
        left: '10px',
        height: '270px',
        width: '480px',
        ...initValues
    });
    const handleChangeInput = (value, name) => {
        setValues(prev => {
            const newValues = { ...prev };
            newValues[name] = value;
            if (lockSizes) {
                if (name === "width") {
                    newValues["height"] = `${(parseInt(value) / ASPECT_RATIO).toFixed(0)}px`;
                } else if (name === "height") {
                    newValues["width"] = `${(parseInt(value) * ASPECT_RATIO).toFixed(0)}px`;
                }
            }

            return newValues;
        });
    };

    const uplaodVideo = () => {
        const MAX_SIZE_MB = 10;
        const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'video/*');
        input.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (file.size > MAX_SIZE_BYTES) {
                if(!window.confirm(texts.uploadBigFile)) {
                return;
            }
        }
            if (typeSupport(file.type)) {
                const url = URL.createObjectURL(file)
                setValues(prev => ({ ...prev, url: url, isFile: true }));
            }
            else {
                alert(texts.fileNotSupported)
            }
        });
        input.click();
    }

    return <div className={classes.Backdrop}>
        <div className={classes.ImageUploadPopup}>
            <div className={classes.Header}>
                <div className={classes.Title}>{texts.addVideo}</div>
                <div className={classes.Close} onClick={close}>x</div>
            </div>
            <div className={classes.InputUrlWrap}>
                <div className={classes.InputWrap}>
                    <div className={classes.InputText}>{texts.urlAdress}</div>
                    <input className={classes.Input} type='text' name={'url'} value={values.url} onChange={(e) => handleChangeInput(e.target.value, e.target.name)}></input>
                </div>
                <div className={classes.ImageUpload} onClick={uplaodVideo}></div>
            </div>
            <div className={classes.GridWrap}>
                <div className={classes.InputWrap}>
                    <div className={classes.InputText}>width</div>
                    <input className={classes.Input} type='number' name={'width'} value={Number(values.width.slice(0, -2))} onChange={(e) => handleChangeInput(e.target.value + 'px', e.target.name)}></input>
                </div>
                <div className={classes.InputWrap}>
                    <div className={classes.InputText}>height</div>
                    <input className={classes.Input} type='number' name={'height'} value={Number(values.height.slice(0, -2))} onChange={(e) => handleChangeInput(e.target.value + 'px', e.target.name)}></input>
                </div>
                <img className={classes.LockIcon} src={lockSizes ? lock : unlock} onClick={() => setLockSizes(!lockSizes)} />
            </div>
            <div className={classes.InputWrap}>
                <div className={classes.InputText}>position</div>
                <div className={classes.GridWrap}>
                    <div className={classes.InputWrap}>
                        <div className={classes.InputText}>top</div>
                        <input className={classes.Input} type='number' name={'top'} value={Number(values.top.slice(0, -2))} onChange={(e) => handleChangeInput(e.target.value + 'px', e.target.name)}></input>

                    </div>
                    <div className={classes.InputWrap}>
                        <div className={classes.InputText}>left</div>
                        <input className={classes.Input} type='number' name={'left'} value={Number(values.left.slice(0, -2))} onChange={(e) => handleChangeInput(e.target.value + 'px', e.target.name)}></input>

                    </div>
                </div>
            </div>
            <div className={classes.Submit} onClick={() => addCallback(values)}>{texts.ok}</div>
        </div>
    </div>
}

export default VideoUploadPopup;